import React, { useState, useMemo } from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
} from '@mui/material'
import {
  Search as SearchIcon,
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
  Business,
} from '@mui/icons-material'
import { PlanListAPI } from '../../Conections/RolesAndPermissionsConection';
import { useAuth } from '../../Auth/AuthProvider';
import { useNavigate } from 'react-router-dom';
import ErrorCard from '../../Conections/ErrorCard';
import { can } from '../../Conections/LogConections';


const initialData = [
  { id: 0, name: '', duration: '', price: '', private: '' },
]

export default function ListRoles() {

  const { getToken, getCompany } = useAuth();
  const goTo = useNavigate();

  const [data, setData] = useState(initialData);
  const [sortConfig, setSortConfig] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [permitido, setPermitido] = React.useState(false);
  const [permitidoShow, setPermitidoShow] = React.useState(false);

  React.useEffect(() => {
    reloaduser();
  }, []);

  async function reloaduser() {
    if (getToken()) {
      const permisionCan = await can(getToken(), getCompany(), "/dashboard/rpp/listplans");
      if (permisionCan === 1) {
        const permisionShowCan = await can(getToken(), getCompany(), "/dashboard/rpp/showplan/:id");
        setPermitidoShow(permisionShowCan === 1);
        const datos = await PlanListAPI(getToken(), getCompany());
        if (typeof datos[0] === "number") {
          setPermitido(false);
        } else {
          setData(datos);
          setPermitido(true);
        }
      }
      else {
        goTo("/dashboard");
      }
    }
    else {
      goTo("/login");
    }
  }

  const sortData = (key) => {
    let direction = 'asc'
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc'
    }
    setSortConfig({ key, direction })
  }

  const sortedAndFilteredData = useMemo(() => {
    let sortableData = [...data]
    if (searchTerm) {
      sortableData = sortableData.filter(
        item =>
          item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.phone.includes(searchTerm) ||
          item.address.toLowerCase().includes(searchTerm.toLowerCase())
      )
    }
    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? -1 : 1
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? 1 : -1
        }
        return 0
      })
    }
    return sortableData
  }, [data, sortConfig, searchTerm])

  return (
    permitido ? (
      <Paper sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ p: 3, flexGrow: 0 }}>
          <Typography variant="h4" gutterBottom color="primary">
            List Panes
          </Typography>
        </Box>
        <Box sx={{ p: 3, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ mb: 2, display: 'flex', alignItems: 'flex-end' }}>
            <SearchIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
            <TextField
              label="Buscar"
              variant="standard"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              fullWidth
            />
          </Box>
          <TableContainer component={Paper} sx={{ flexGrow: 1, overflow: 'auto' }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {['name', 'duration', 'price', 'private'].map((key) => (
                    <TableCell
                      key={key}
                      onClick={() => sortData(key)}
                      sx={{ cursor: 'pointer' }}
                    >
                      {key.charAt(0).toUpperCase() + key.slice(1)}
                      {sortConfig?.key === key && (
                        sortConfig.direction === 'asc' ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedAndFilteredData.map((person) => (
                  <TableRow
                    key={person.id}
                    onClick={() => setSelectedPerson(person)}
                    selected={selectedPerson?.id === person.id}
                    hover
                  >
                    <TableCell>{person.name}</TableCell>
                    <TableCell>{person.duration}</TableCell>
                    <TableCell>{person.price}</TableCell>
                    <TableCell>{person.private}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {selectedPerson && (
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
              {
                permitidoShow ? (
                  <Button
                    startIcon={<Business />}
                    onClick={() => goTo(`/dashboard/rpp/showplan/${selectedPerson.id}`)}
                    sx={{ mr: 1 }}
                  >
                    Show
                  </Button>
                ) : (
                  <></>
                )
              }
            </Box>
          )}
        </Box>
      </Paper>
    ) : (
      <ErrorCard />
    )
  )
}